module.exports = __webpack_public_path__ + "img/Crmimg.8aa3d2b2.png";